<template>
    <div name="snackbars">
        <v-snackbar v-model="show" :color="color" :timeout="timeout">
            {{ message }}
            <template #actions="{ attrs }" v-if="button">
                <v-btn v-bind="attrs" :color="button.color" variant="text" @click="button.callback">
                    {{ button.text }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { useGlobalState } from '@/stores/globalState';

export default {
    setup() {
        return {
            globalState: useGlobalState(),
        }
    },
    data() {
        return {
            show: false,
            color: '',
            message: '',
            timeout: -1,
            button: null,
        };
    },
    created() {
        this.globalState.$onAction(({ name, args }) => {
            if (name === 'showSnackbar') {
                const sbData = args[0];
                this.$nextTick(() => {
                    this.show = true;
                    this.message = (sbData || this.globalState?.snackbar)?.message;
                    this.color = (sbData || this.globalState?.snackbar)?.color;
                    this.timeout = (sbData || this.globalState?.snackbar)?.timeout;
                    this.button = (sbData || this.globalState?.snackbar)?.button;
                })
            }
            if (name === 'closeSnackbar') {
                this.$nextTick(() => {
                    this.show = false;
                    this.message = null;
                    this.color = null;
                    this.timeout = null;
                    this.button = null;
                });
            }
        }, true);
        
    },
};
</script>
